import React, { useContext } from "react";
import PropTypes from "prop-types";
import { addDays, format } from "date-fns";
import { toast } from "react-toastify";
import Overlay from "../../Overlay";
import Button from "../../common/Button";
import AppContext from "../../../AppContext.jsx";
import { langComponent } from "../../../constants/index.jsx";
import {
  FacebookShareButton,
  LineShareButton,
  WeiboShareButton,
  WeiboIcon,
  FacebookMessengerShareButton,
  FacebookMessengerIcon,
} from "react-share";
import { useParams } from "react-router-dom";

import { ReactComponent as ShareSvg } from "../../../assets/workExchange/icon-share.svg";
import { ReactComponent as FacebookSvg } from "../../../assets/icons/facebook.svg";
import { ReactComponent as LineSvg } from "../../../assets/icons/line.svg";
import { ReactComponent as CopyLinkSvg } from "../../../assets/icons/copy-link.svg";

//style
import "../../../styles/allWorkExchangeModal.scss";

function SharePopup({ onClose }) {
  const { getLang } = useContext(AppContext);
  const { id } = useParams();
  const Translation = getLang(langComponent.profile);
  const TranslationCommon = getLang(langComponent.common);
  const TranslationWorkExchange = getLang(langComponent.workExchange);

  const link = window.location.href;

  function handleCopy() {
    navigator.clipboard.writeText(link);
    toast.success(TranslationWorkExchange("Copied work link to clipboard"));
  }

  return (
    <Overlay
      onClose={onClose}
      content={
        <div className="profile-share">
          <h3 className="profile-share__header">{Translation("Share")}</h3>
          <div className="profile-share-list">
            <div className="profile-share-list-item" onClick={handleCopy}>
              <div className="profile-share-list-item__border">
                <CopyLinkSvg className="profile-share-list-item__icon profile-share-list-item__icon--small" />
              </div>
              {Translation("Copy Link")}
            </div>
            <FacebookShareButton url={link}>
              <div className="profile-share-list-item">
                <FacebookSvg className="profile-share-list-item__icon" />
                Facebook
              </div>
            </FacebookShareButton>
            <LineShareButton url={link}>
              <div className="profile-share-list-item">
                <LineSvg className="profile-share-list-item__icon" />
                Line
              </div>
            </LineShareButton>
            {/* <WeiboShareButton url={link}>
              <div className="profile-share-list-item">
                <WeiboIcon className="profile-share-list-item__icon" />
                Weibo
              </div>
            </WeiboShareButton>
            <FacebookMessengerShareButton url={link}>
              <div className="profile-share-list-item">
                <FacebookMessengerIcon className="profile-share-list-item__icon" />
                Messenger
              </div>
            </FacebookMessengerShareButton> */}
          </div>
        </div>
      }
    />
  );
}

SharePopup.propTypes = {};

export default SharePopup;
